// Static Assets
import { IItemDetail } from 'api/types/marketplace';

import Frame648 from '../../../assets/images/frames/frame_648x648@2x.png';
import Frame648Blank from '../../../assets/images/frames/frame_648x648_blank@2x.png';

interface Props {
  itemDetailObj: IItemDetail;
}

const ProfileFrame = ({ itemDetailObj }: Props) => {
  return (
    <div className="frame-648">
      {itemDetailObj.largeImageUrl && (
        <img
          src={itemDetailObj.largeImageUrl}
          alt={`${itemDetailObj.title} card`}
          className="card-picture card-picture-profile img-fluid"
        />
      )}
      <img
        src={itemDetailObj.largeImageUrl ? Frame648Blank : Frame648}
        alt="Frame648Blank"
        className="card-picture img-fluid top-0"
      />
    </div>
  );
};

export default ProfileFrame;
